import { observable, action } from 'mobx';
import 'promise.prototype.finally';
import { ApolloClient } from 'apollo-client';

export interface ApolloStoreInterface {
    isProvided: boolean;
    apolloClient?: ApolloClient<any>;
}

class ApolloStore {
    @observable isProvided = false;
    @observable client: any = null;
    
    @action setProvided(to?: boolean) {
        if (typeof to === 'undefined' || to) {
            this.isProvided = true;
        } else {
            this.isProvided = false;
        }
    }

    @action setClient(client?: any) {
        if (!this.client) {
            this.client = client;
        }
        //  (window as any).__APOLLO_CLIENT__ = client;
        
    }

    runQueryWhenClientLoaded(runnable: any) {
        if (this.isProvided) {
            runnable(this.client);
        } else {
            setTimeout(this.runQueryWhenClientLoaded, 100, runnable);
        }
    }

    promiseToRunQueryWhenClientLoads() {
        const me = this;
        return new Promise((res, rej) => {
            me.runQueryWhenClientLoaded(res);
        });
    }
  
}

export default new ApolloStore();



// WEBPACK FOOTER //
// ./src/stores/apolloStore.ts